import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiState } from "@baseTypes/baseType";
import OrganizationService, { AsClientNode } from "@api/auth/OrganizationService";
import { AsOrganization } from "@baseTypes/service/ICompanyService";
import { applyExtraReducer } from "../../weather";
import { TryServerResponseNRequest, TryServerResponseRequest } from "../../auth";


interface OrganizationState extends ApiState {
    data: AsOrganization[]
    tree?: AsClientNode
}

const fetchOrganizations = createAsyncThunk(
    'references/organizations',
    async (_, thunkAPI) => {
        return TryServerResponseRequest(() => OrganizationService.fetch(), thunkAPI)
    }
)

const fetchOrganizationsTree = createAsyncThunk(
    'references/organizations/tree',
    async (_, thunkAPI) => {
        return TryServerResponseNRequest(() => OrganizationService.fetchTree(), thunkAPI)
    }
)

const organizationsSlice = createSlice({
    name: 'organizationsSlice',
    initialState: {
        data: [],
        apiError: undefined,
        tree: undefined,
        isApiLoading: false
    } as OrganizationState,
    reducers: {},
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchOrganizations)
        applyExtraReducer(builder, fetchOrganizationsTree, {
            rejectReducer(state, action) {
                state.tree = undefined
            },
            fulfillReducer(state, action) {
                state.tree = action.payload
            }
        })
    },
})

export const actions = { ...organizationsSlice.actions, fetchOrganizations, fetchOrganizationsTree }
export default organizationsSlice.reducer